import { useEffect, useRef, useState } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { MdFormatListBulleted, MdOutlineFileDownload } from "react-icons/md";
import { SlPencil } from "react-icons/sl";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ROLE } from "../../constants/common";
import { RESET_LOADER, SET_LOADER } from "../../constants/contexConstant";
import {
    LEASE_DETAILS,
    PROPOSAL,
    PROPOSAL_DOCUMENT_META_ENDPOINT,
    PURCHASE_DETAILS,
    SURVEY_VIEW_LABEL,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import { checkIsAllowed } from "../../helpers/helpers";
import useFileUploadAndRemove from "../../hooks/useFileUploadAndRemove";
import cn from "../../lib/cn";
import {
    locationLight,
    statusImages,
    tap,
    whiteApartment,
} from "../../resources/js/icons";
import SolarLeaseTemplate from "../../resources/templates/SolarLeaseTemplate";
import SolarPurchaseTemplate from "../../resources/templates/SolarPurchaseTemplate";
import request from "../../services/request";
import Container from "../../shared/Container";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
import CustomButton from "../../shared/ui/CustomButton";
import TextField from "../../shared/ui/Form/TextField";
import TableComponent from "../../shared/ui/Table";
import Tag from "../../shared/ui/tag/Tag";
const columns = ["Description", "Plan Details"];

const ProposalTable = ({
    currentTab,
    selected,
    tableData,
    options,
    downloadProposalDocument,
    url,
    propertyName,
    setDis,
    solarPlantSize,
    solarData,
    setShowDrawer,
    isSubsidy = false,
    setGST,
    setSubsidyAmount,
    subsidyAmount,
    connectionType,
}) => {
    const history = useHistory();
    const { state, dispatch } = useContextState();
    const { id } = useParams();
    const componentRef = useRef();
    const [purchasedataTemplate, setPurchaseDataTemplate] = useState(null);
    const [leasedataTemplate, setLeaseDataTemplate] = useState(null);

    const {
        file,
        setFile,
        uploadedDoc,
        uploading,
        setUploadedDoc,
        handleFileChange,
        removeFile,
    } = useFileUploadAndRemove();

    const [showLeaseModal, setShowLeaseModal] = useState(false);
    const textToCopy = `Join Our Solar Community.  

    You can earn up to 20% returns, and your society will benefit from significant savings on electricity bills. It's a win-win for everyone!  
    Together, our small contributions can make a big difference.  
    
    ${url}
    `;

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            toast.success("Text copied to clipboard!");
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const endpoint = `${PROPOSAL_DOCUMENT_META_ENDPOINT}/${id}/${selected}`;

                try {
                    dispatch({ type: SET_LOADER });
                    const leasedata = await request.authPost({
                        endpoint: endpoint,
                        body: {
                            type: "lease",
                            isSubsidy: isSubsidy,
                        },
                    });
                    dispatch({ type: RESET_LOADER });
                    setLeaseDataTemplate(leasedata?.data?.data);
                } catch (error) {
                    dispatch({ type: RESET_LOADER });
                }

                try {
                    dispatch({ type: SET_LOADER });
                    const purchasedata = await request.authPost({
                        endpoint: endpoint,
                        body: {
                            type: "purchase",
                            isSubsidy: isSubsidy,
                        },
                    });
                    dispatch({ type: RESET_LOADER });
                    setPurchaseDataTemplate(purchasedata?.data?.data);
                    setGST(purchasedata?.data?.data?.gst);

                    const cleaned =
                        purchasedata?.data?.data?.governmentSubsidy?.replace(
                            /[₹,\s]/g,
                            ""
                        );
                    const parsed = parseInt(cleaned, 10);

                    setSubsidyAmount(parsed);
                } catch (error) {
                    dispatch({ type: RESET_LOADER });
                }
            } catch (error) {
                dispatch({ type: RESET_LOADER });
            }
        };

        if (selected) {
            fetchData();
        }
    }, [selected, isSubsidy]);

    return (
        <>
            <Container className=" bg-white min-h-[80vh]  lg:min-h-full  min-w-full lg:shadow-xl lg:border   lg:min-w-full    mx-0 rounded-t-3.5 lg:rounded-2xl px-2 py-3 lg:p-2">
                <div className=" hidden lg:flex justify-between flex-wrap items-stretch md:items-center">
                    <div
                        className={cn(
                            "bg-linear-blue-white p-1.5 mt-3 mb-2 lg:my-2   lg:m-auto  lg:py-2 gap-2 flex w-full flex-col rounded-3xl  justify-center  items-center "
                        )}
                    >
                        <div className="flex w-full flex-col gap-0.5 xs:gap-1 justify-stretch">
                            <div className="flex justify-between items-center gap-2">
                                <div className="flex items-center gap-1">
                                    <img
                                        src={whiteApartment}
                                        alt="whiteApartment"
                                        className="w-3 h-3"
                                    />
                                    <div className=" w-full ">
                                        <TextField
                                            label={""}
                                            value={propertyName}
                                            size={
                                                "w-full md:min-w-[24rem] bg-none !bg-transparent"
                                            }
                                            name="name"
                                            disabled={true}
                                            placeholder=""
                                            wrapper={
                                                "md:h-[5rem] px-0 !border-none !bg-none !bg-transparent"
                                            }
                                            inputWrapper="rounded-l-md px-0 py-0 md:p-1 text-xs !text-white !border-none !bg-none !bg-transparent text-clip "
                                            type="text"
                                            icon={<SlPencil />}
                                            iconWrapperClass={`py-[1.4rem] px-[1.5rem] !border-none text-white flex items-center rounded-r-md   `}
                                            iconChange={() => {
                                                setDis((prev) => !prev);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="flex gap-2 items-center">
                                    <Tag
                                        text={<p># {connectionType}</p>}
                                        className={
                                            " bg-gray-100 rounded-xl p-0.2"
                                        }
                                        textClass={
                                            "text-secondary  gap-0.5 text-nowrap !text-xs"
                                        }
                                    />
                                    <Tag
                                        text={id}
                                        className={
                                            " bg-gray-100 rounded-xl p-0.2"
                                        }
                                        icon={
                                            <img
                                                src={statusImages.hot}
                                                alt="fire"
                                                className="h-2"
                                            />
                                        }
                                        textClass={
                                            "text-secondary  gap-0.5 text-nowrap !text-xs"
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full items-center justify-between gap-1">
                            <p className="text-white flex items-start gap-0.8  text-sm xsm:w-[40%] ">
                                <img
                                    src={locationLight}
                                    alt="locationLight"
                                    className="mt-0.2"
                                />
                                {solarData?.siteAddress}
                            </p>
                            <div className="flex items-center gap-3">
                                <div className="flex flex-col items-start">
                                    <H4 className="text-xs xs:text-sm sm:text-nowrap text-white md:text-base xl:text-base ">
                                        {solarPlantSize} KWp
                                    </H4>
                                    <P className=" text-xs text-nowrap text-white md:text-sm xl:text-sm">
                                        Plant Size
                                    </P>
                                </div>
                                <div
                                    className={`bg-blue-200 w-0.1 min-h-[5rem]  max-h-[6rem]
                                                                                `}
                                />
                                <div className="flex flex-col items-start">
                                    <H4 className="text-xs sm:text-nowrap xs:text-sm text-white md:text-base xl:text-base ">
                                        ₹{" "}
                                        {Number(
                                            solarData?.monthlyElectricBill
                                        ).toLocaleString()}
                                    </H4>
                                    <P className="text-xs text-nowrap text-white md:text-sm xl:text-sm ">
                                        Consumer's Bill
                                    </P>
                                </div>
                            </div>
                        </div>
                    </div>
                    {subsidyAmount > 0 && (
                        <div className="flex text-center justify-center items-center p-0.2  w-full rounded-2xl lg:rounded-none mb-2 bg-green-100">
                            <P className="text-green-200 text-xs md:text-sm xl:text-sm">
                                Society will receive {subsidyAmount} govt.
                                subsidy
                            </P>
                        </div>
                    )}
                </div>
                <div className="hidden lg:flex flex-wrap sm:flex-nowrap gap-1 justify-between items-center lg:mt-2">
                    <div className="flex gap-0.5 items-center">
                        <div className=" py-0.5">
                            <H4 className="font-medium">
                                {options[currentTab]} Plan
                            </H4>
                        </div>
                        <div className="bg-gray-100  rounded-3xl px-2 py-0.5">
                            <P className="font-thin"> # {selected}</P>
                        </div>
                    </div>
                    <div className=" flex items-center gap-2">
                        {/* {checkIsAllowed(state?.user?.roles, [
                            ROLE.SUPER_ADMIN,
                            ROLE.SALES_MANAGER,
                        ]) &&
                            options[currentTab] === "Lease" &&
                            url && (
                                <CustomButton
                                    icon={<SlShare />}
                                    onClick={() => setShowShareModal(true)}
                                />
                            )}
                                */}
                        {checkIsAllowed(state?.user?.roles, [
                            ROLE.SUPER_ADMIN,
                            ROLE.SALES_MANAGER,
                        ]) &&
                            options[currentTab] === "Lease" && (
                                <CustomButton
                                    icon={
                                        <img
                                            src={tap}
                                            alt="tap"
                                            className="w-1.8"
                                        />
                                    }
                                    onClick={() => setShowLeaseModal(true)}
                                />
                            )}

                        <CustomButton
                            icon={<IoEyeOutline />}
                            onClick={() => {
                                options[currentTab] === "Lease"
                                    ? history.push(
                                          `${LEASE_DETAILS}/${id}/${selected}?isSubsidy=${isSubsidy}`
                                      )
                                    : history.push(
                                          `${PURCHASE_DETAILS}/${id}/${selected}?isSubsidy=${isSubsidy}`
                                      );
                            }}
                        />
                        <CustomButton
                            icon={<MdOutlineFileDownload />}
                            onClick={downloadProposalDocument}
                        />
                        <CustomButton
                            icon={<MdFormatListBulleted />}
                            onClick={() => setShowDrawer((prev) => !prev)}
                        />
                    </div>
                </div>
                <div className="hidden lg:block lg-w-full lg:border-0.5 lg:border-blue-250 my-1"></div>
                <div className="bg-white  rounded-xl   md:py-1.5 ">
                    {checkIsAllowed(state?.user?.roles, [
                        ROLE.SUPER_ADMIN,
                        ROLE.SALES_MANAGER,
                    ]) && (
                        <div className="flex justify-between items-center">
                            <P className=" lg:hidden md:text-sm xl:text-sm bg-blue-200 px-1 py-0.5 rounded-2xl">
                                Solar Plan Details
                            </P>
                            <div className="lg:hidden flex flex-wrap items-center gap-1 my-1">
                                <CustomButton
                                    icon={<IoEyeOutline />}
                                    onClick={() => {
                                        options[currentTab] === "Lease"
                                            ? history.push(
                                                  `${LEASE_DETAILS}/${id}/${selected}?isSubsidy=${isSubsidy}`
                                              )
                                            : history.push(
                                                  `${PURCHASE_DETAILS}/${id}/${selected}?isSubsidy=${isSubsidy}`
                                              );
                                    }}
                                />
                                <CustomButton
                                    icon={<MdOutlineFileDownload />}
                                    onClick={downloadProposalDocument}
                                />
                                <CustomButton
                                    icon={<MdFormatListBulleted />}
                                    onClick={() =>
                                        setShowDrawer((prev) => !prev)
                                    }
                                />
                            </div>
                        </div>
                    )}
                    <TableComponent
                        columns={columns}
                        data={tableData}
                        headerColor="bg-gray-170 text-nowrap rounded-3xl lg:bg-blue-300"
                        oddRowColor=" lg:bg-gray-170 rounded-3xl"
                        additionalRowClassName="border-t border-t-gray-170 md:border-none rounded-xl"
                        borderStyle="border-collapse "
                        fontSize="text-xs md:text-sm"
                    />
                </div>
                <div className="flex justify-between items-center gap-2 mb-5 mt-2 md:my-2">
                    <Button
                        onClick={() =>
                            history.push(`/${SURVEY_VIEW_LABEL}/${id}`)
                        }
                        className=" w-full lg:w-1/2"
                    >
                        Survey
                    </Button>
                    {checkIsAllowed(state?.user?.roles, [
                        ROLE.SUPER_ADMIN,
                        ROLE.SALES_MANAGER,
                    ]) && (
                        <CustomButton
                            text="Revise"
                            className={"w-full lg:w-1/2"}
                            onClick={() =>
                                history.push(
                                    `${PROPOSAL}/${id}/${selected}/revision`
                                )
                            }
                        />
                    )}
                </div>
                <div className="hidden">
                    {options[currentTab] === "Lease" && leasedataTemplate ? (
                        <SolarLeaseTemplate
                            ref={componentRef}
                            data={leasedataTemplate}
                        />
                    ) : (
                        <SolarPurchaseTemplate
                            ref={componentRef}
                            data={purchasedataTemplate}
                        />
                    )}
                </div>
            </Container>
        </>
    );
};

export default ProposalTable;
